var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"ml-0",attrs:{"color":_vm.color,"left":_vm.left,"right":_vm.right,"disabled":_vm.disabledComputed},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.iconName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }